module.exports = __webpack_public_path__ + "static/media/Register.ed4bb498.jpeg";